import { ISelectable } from '../../global/servants/selection_list_servant';

export class ExamType implements ISelectable {
  isSelected: boolean = false;
  code: string;
  id: number;
  title: string;
  nk: string;
  about_text: string;
  score_help_text: string;
  min_score: number;
  max_score: number;
  ordering: number;

  constructor(examtype: Partial<ExamType>) {
    _.merge(this, examtype);
  }

  static build(examtype: ExamType): ExamType {
    return new ExamType(examtype);
  }
}

angular.module('capability-ng-transfer').factory('ngExamTypeBuilder', function(): typeof ExamType {
  return ExamType;
});



// WEBPACK FOOTER //
// ./app/lib/transfer/builders/exam_type_builder.ts